import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardHeader, CardContent } from "components/ui/card";
import { useAuth } from "contexts/AuthContext";
import { useI18n } from "i18n";

/**
 * Callback do fluxo OIDC: o backend redireciona para
 * `/sso/callback#token=<JWE>` após autenticação bem-sucedida no IdP,
 * ou `/sso/callback#error=<mensagem>` em caso de falha.
 *
 * Lemos o fragment (nunca vai para o servidor) e finalizamos o login.
 */
export default function OidcCallback() {
  const navigate = useNavigate();
  const { loginUser, fetchUser } = useAuth();
  const { t } = useI18n();
  const [error, setError] = useState("");

  useEffect(() => {
    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
    const token = params.get("token");
    const err = params.get("error");

    if (err) {
      setError(err);
      return;
    }

    if (!token) {
      setError(t("sso.error"));
      return;
    }

    (async () => {
      try {
        loginUser({}, token);
        await fetchUser();
        window.history.replaceState(null, "", "/app/dashboard");
        navigate("/app/dashboard", { replace: true });
      } catch (e) {
        setError(t("sso.error"));
      }
    })();
  }, [loginUser, fetchUser, navigate, t]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f5f5f7] px-4 py-8">
      <div className="w-full max-w-[420px]">
        <Card className="shadow-lg border-0 bg-white rounded-2xl">
          <CardHeader className="text-center">
            <h1 className="text-2xl font-bold tracking-tight text-gray-900">
              {error ? t("sso.failed") : t("sso.finishing")}
            </h1>
          </CardHeader>
          <CardContent className="text-center">
            {error ? (
              <>
                <p className="text-sm text-red-500 mb-4">{error}</p>
                <button
                  type="button"
                  onClick={() => navigate("/app/login", { replace: true })}
                  className="text-sm text-blue-600 hover:underline font-medium"
                >
                  {t("sso.backToLogin")}
                </button>
              </>
            ) : (
              <p className="text-sm text-gray-500">{t("sso.wait")}</p>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
